<template>
  <div v-if="activeVenue">
    <h3>Booking overview</h3>
    <vs-tabs
      class="tabs-shadow-none mt-4"
      id="profile-tabs"
      :key="isSmallerScreen"
    >
      <vs-tab
        v-if="$AuthService.hasPermissionForActiveVenue('vp.crm.bookingoverview.viewvenueoverview')"
        icon-pack="feather"
        icon="icon-activity"
        :label="!isSmallerScreen ? 'Venue Overview ' : ''"
      >
        <div class="tab-general">
          <guest-relations-venue-overview />
        </div>
      </vs-tab>
      <vs-tab
        v-if="$AuthService.hasPermissionForActiveVenue('vp.crm.bookingoverview.viewpendingrequests')"
        icon-pack="feather"
        icon="icon-info"
        :label="!isSmallerScreen ? 'Pending Requests' : ''"
      >
        <div class="tab-general">
          <pending-requests-overview :venueSpecific="false" :showFilters="true"/>
        </div>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import GuestRelationsVenueOverview from "./pages/GuestRelationsVenueOverview.vue";
import PendingRequestsOverview from "./pages/PendingRequestsOverview.vue";
import { mapGetters } from "vuex";
import { ACTIONS as VENUE_ACTIONS } from "@/store/modules/marcom/marcom";

export default {
  components: {
    GuestRelationsVenueOverview,
    PendingRequestsOverview,
  },
  data() {
    return {};
  },

  async created() {
    await this.$store.dispatch("marcom/" + VENUE_ACTIONS.GetBookingTags);
    
  },
  mounted() {},
  methods: {},
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
    }),
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    },
  },
};
</script>
